<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="我的开票"
				left-arrow
				@click-left="onNavBarLeft"
			/>
			<div class='tab ui-flex'>
				<div v-for="(item,index) in tab" class='tab_item ui-flex-1' :class="{ 'cur' : index == tab_index}">
					<span @click='bindtab(index)'>{{item.name}}</span>
				</div>
			</div> 
		</div>
		<div style="height: 95px;"></div>
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" style="padding: 10px;">
			<div class='list' v-for="item in list">
				<div class='invoice-head ui-flex'>
					<div class='c_999 ui-flex-1'>{{$formatDate(item.createTime,'yyyy-MM-dd hh:mm')}}</div>
					<div class='invoice_status gd-icon'>
						<div v-if="item.payInvoiceType == 1" class='c_warning'>未支付</div>
						<div v-else>
							<div class="c_warning" v-if="item.invoiceStatus == 1">待开票</div>
							<div class="c_success" v-if="item.invoiceStatus == 2">已开票</div>
							<div class='c_999' v-if="item.invoiceStatus == 3">已取消</div>
						</div>
					</div>
				</div>
				<div class="invoice-info" @click="details(item.id)">

					<div class="invoice-info-item"><span class="c_999">开票抬头：</span>{{item.receiverCompanyName}}</div>
					<div class="invoice-info-item"><span class="c_999">开票类目：</span>{{item.serviceContent}}</div>
					<div class='ui-flex'>
						<div class="ui-flex-1">
							<div class="invoice-info-item">
								<span class="c_999">合同凭证：</span>
								<span class="c_999" v-if="item.contractType == 1">未上传</span>
								<span v-if="item.contractType == 2">审核中</span>
								<span v-if="item.contractType == 3">通过</span>
								<span class='c_red' v-if="item.contractType == 4">未通过</span>
							</div>
							<div class="invoice-info-item">
								<span class="c_999">流水凭证：</span>
								<span class="c_999" v-if="item.cashStatus == 1">未上传</span>
								<span v-if="item.cashStatus == 2">
									<span v-if="item.cashVerifyStatus == 1">审核中</span>
									<span v-if="item.cashVerifyStatus == 2">通过</span>
									<span class='c_red' v-if="item.cashVerifyStatus == 3">未通过</span>
								</span>
							</div>
						</div>
						<div class='invoice-amount'><div class="fh">￥</div><div>{{item.invoiceAmount/100}}</div>
						</div>
					</div>
				</div>
			</div>
				
		</van-list>
	</div>
</template>

<script>
	export default {
		name: '',
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				pageNo : 1,
				tab: [{
				      name: '全部',
				      params: {
				        invoiceStatus: ''
				      }
				    }, {
				      name: '待支付',
				      params: {
				        invoiceStatus: 88
				      }
				    }, {
				      name: '待开票',
				      params: {
				        invoiceStatus: 1
				      }
				    }, {
				      name: '已开票',
				      params: {
				        invoiceStatus: 2
				      }
				    }, {
				      name: '补流水',
				      params: {
				        invoiceStatus: 99
				      }
				    }, {
				      name: '已取消',
				      params: {
				        invoiceStatus: 3
				      }
				}],
				tab_index: 0
			}
		},
		mounted() {
		},
		methods: {
			bindtab(index) {
				this.tab_index = index;
				this.pageNo = 1;
				this.list = [];
			    this.getList();
			},
			getList() {
				this.loading = true;
				var params = this.tab[this.tab_index].params;
				params.pageNo = this.pageNo;
				this.$get('/gtb/home/invoice.html',params).then((res) => {
					this.loading = false;
					if (res.success) {
						const pList = res.pList.pageRecords;
						this.list = this.list.concat(pList);
						this.pageNo = this.pageNo + 1;
						this.finished = this.list.length >= res.pList.totalSize;
					}else{
						this.loading = false;
					}
				}).catch((res) => {
					this.loading = false;
				});
			},
			details(id) {
				this.$router.push('/invoice/details?invoiceId=' + id);
			},
			onNavBarLeft(){
				this.$router.go(-1);
			}
		}
	}
</script>
<style scoped>
	.tab{ background: #fff; box-shadow: 0 2px 6px rgba(0,0,0,0.06); height: 44px;line-height: 44px; text-align: center; font-size: 15px; width: 100%; z-index: 10;}
	.tab_item span{ display: inline-block; position: relative; font-size: 13px; }
	.tab_item.cur{ color: #2f86f6;font-weight: bold;}
	.tab_item.cur span::after{ content: ''; display: block; height: 3px; width: 100%; background: #2f86f6; position: absolute;bottom: 0;border-radius: 6px;}
	
	.list{background: #fff; padding: 16px; margin-bottom: 10px; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,0.05);}
	.invoice-head{ margin-bottom: 10px;}
	.invoice_status{ position: relative; padding-right: 12px;}
	.invoice-amount{ font-size: 20px; padding-top: 5px; font-weight: bold;display:flex;align-items:flex-end;}
	.invoice-amount .fh{ font-size: 15px; }
	.invoice-info{ font-size: 13px;}
	.invoice-info-item{ padding: 1px 0;}

</style>
